<template>
    <div>
        <div class="d-flex justify-content-center">
            <b-card class="text-center m-1">
                <div class="m-3">
                    <p>
                        <feather-icon
                            icon="XCircleIcon"
                            size="80"
                            class="text-danger"
                        />
                    </p>
                    <h2>Oh No, Payment Failed.</h2>
                    <p>Please go back and try again.</p>
                </div>
                <b-button variant="primary" class="mb-1" @click="retryPayment">
                    Try Payment Again
                </b-button>
                <b-button
                    variant="outline-primary"
                    class="mb-1 ml-50"
                    :to="{ name: 'plans' }"
                >
                    View Plans
                </b-button>
                <p class="mb-1">
                    Still having trouble?
                    <b-link :to="{ name: 'support' }">Contact Support</b-link>
                </p>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard, BButton, BLink } from "bootstrap-vue";
import { getCheckoutIntent } from "@/utils/checkout-intent";
export default {
    components: {
        BCard,
        BButton,
        BLink,
    },
    created() {
        this.$gtag.event("payment_failed");
    },
    methods: {
        retryPayment() {
            const checkoutPath = getCheckoutIntent();

            if (checkoutPath) {
                this.$router.push(checkoutPath);
                return;
            }

            this.$router.push({ name: "plans" });
        },
    },
};
</script>

<style></style>
